
    <template>
     <zm-drawer @ok="handleSubmit" :title="title" :width="drawerWidth" :visible="visible" size="large" @cancel="open(false)">
        <div slot="drawerBody">
        <a-form :form="form" >
          <a-row>
          <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="应用名称"
              hasFeedback
            >
              <a-input
                placeholder="请输入应用名称"
                id="appName"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"  v-decorator="['appName', { rules: [{ required: true, message: '请输入应用名称！' }] }]"/>
            </a-form-item>
           </a-col>
            <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="IP地址"
              hasFeedback
            >
              <a-input
                placeholder="请输入IP地址"
                id="ip"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"  v-decorator="['ip', { rules: [{ required: true, message: '请输入IP地址！' }] }]"/>
            </a-form-item>
           </a-col>
            <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="端口"
              hasFeedback
            >
              <a-input
                placeholder="请输入端口"
                id="port"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"  v-decorator="['port', { rules: [{ required: true, message: '请输入端口！' }] }]"/>
            </a-form-item>
           </a-col>
            <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="扫描接口"
              hasFeedback
            >
              <a-input
                placeholder="请输入扫描接口"
                id="scanUrl"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"  v-model="model.scanUrl"/>
            </a-form-item>
           </a-col>
            <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="文件获取接口"
              hasFeedback
            >
              <a-input
                placeholder="请输入文件获取接口"
                id="getUrl"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"  v-decorator="['getUrl', { rules: [{ required: true, message: '请输入文件获取接口！' }] }]"/>
            </a-form-item>
           </a-col>

          </a-row>
        </a-form>
      </div>
      </zm-drawer>
    </template>
<script>
import moment from 'moment';
import { mapState } from 'vuex'

import { getFpsAppInfo, insertFpsApp, updateFpsApp } from '@/api/fps'
export default {
  name: 'editFps',
  mounted () {

  },
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    drawerWidth () {
      const width = window.innerWidth - 200
      return width
    },
    ...mapState({


    })
  },
  components: {

  },
  data () {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'fps' }),
      visible: false,
      defaultModel: {},
      model: {

    accountId : '',
    authToken : '',
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 21 }
      },
      colSpan:12,


    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.visible = flag
      if ((this.type === this.$sysInfo.MODAL_MODIFY) || (this.type === this.$sysInfo.MODAL_VIEW)) {
        if(flag){
            this.$nextTick(() => {
                 this.form.setFieldsValue({
      appName: this.model.appName,
      ip: this.model.ip,
      port: this.model.port,
      scanUrl: this.model.scanUrl,
      getUrl: this.model.getUrl,})
           })
          // this.getModelInfo(this.model) 通过接口获取详情
        }
      }else{
        this.formClear()
      }
    },
    // 提交表单
    handleSubmit () {
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const params = { ...this.model, ...value }
          if (this.type === this.$sysInfo.MODAL_ADD) {
          delete params.id
              const res = await insertFpsApp(params).catch(error => {
                console.log('更新失败', error)
                this.$message.error('更新失败，请稍后重试！')
              })
              if (res && res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.warning(res.info.message)
              }
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
              const res = await updateFpsApp(params).catch(error => {
                console.log('更新失败', error)
                this.$message.error('更新失败，请稍后重试！')
              })
              if (res && res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.warning(res.info.message)
              }
          }
        }
      })
    },
    // 获取当前的model详情

    handleChange () {

    },
    // 清空表单
    formClear () {
        this.$nextTick(() => {
        this.model = {}
             this.form.setFieldsValue({appName: '',ip: '',port: '',scanUrl: '',getUrl: '',})
            //
      this.model.accountId= ''
      this.model.authToken= ''
      })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 获取select列表

  },
}
</script>

<style scoped lang="less">

</style>

